import BAApi from './_baApi';
import httpClient from '@/apis/base/httpclient';

class BADepositAPI extends BAApi {
  constructor() {
    super();
  }
  controllerName = 'BADeposits';

  // Xóa nhiều
  async customDelete(payload) {
    let request = {
      url: this.getAPIUrl() + '/CustomDelete',
      data: payload,
    };

    return await httpClient.deleteAsync(request);
  }

  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new BADepositAPI();
